import BillingState from 'Types/_Store/Billing'
import { ActionTree, MutationTree, GetterTree, Getter } from 'vuex'
import { StoreState, ApiBillingInfo } from 'Types'
import { getBillingData, addBillingData, updateBillingData } from 'Api/billingApi'
import { parseBillingInfo } from 'Parsers/billingParser'
import { formatBillingEdit } from 'Formatters/billingFormatter'
import brazilStates from 'Enums/brazilStates'

const state: BillingState = {
  isFirstEntry: false,

  requesting: {
    fetch: false,
    update: false
  },

  region: {
    cityName: '',
    stateName: '',
  },

  info: {
    name: '',
    email: '',
    freelancer: false,
    cpfcnpj: '',
    phone: {
      number: '',
      ddd: '',
    },
    location: {
      city: null,
      state: null,
      neighborhood: '',
      street: '',
      streetDetails: '',
      streetNumber: '',
      zipcode: '',
    }
  },
}

const getters: GetterTree<BillingState, StoreState> = {
  invalidLocation: (state) => {
    const { neighborhood, street, streetNumber, zipcode } = state.info.location
    const { city: cityId, state: stateId } = state.info.location

    const invalidAdress = [neighborhood, street, streetNumber, zipcode].includes('')
    const invalidRegion = [cityId, stateId].includes(null) === false

    return invalidAdress && invalidRegion
  }
}

const mutations: MutationTree<BillingState> = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_first_entry(state, isFirstEntry) {
    state.isFirstEntry = isFirstEntry
  },

  set_region(state, region) {
    Object.assign(state.region, region)
  },

  set_info(state, info) {
    Object.assign(state.info, info)
  },

  set_info_phone(state, phone) {
    Object.assign(state.info.phone, phone)
  },

  set_info_location(state, location) {
    Object.assign(state.info.location, location)
  },
}

const actions: ActionTree<BillingState, StoreState> = {
  getRegion({ commit }, data: ApiBillingInfo) {
    const { city: cityName } = data
    const stateName = brazilStates.getDescriptionByValue(data.stateId)

    commit('set_region', { cityName, stateName })
  },

  async getData({ commit, dispatch }) {
    commit('request_start', 'fetch')

    try {
      const { data } = await getBillingData()
      const isDataEmpty = (data === null || data === '')

      if (isDataEmpty) {
        commit('set_first_entry', true)
      } else {
        const info = parseBillingInfo(data)
        commit('set_info', info)

        dispatch('getRegion', data)
      }

      commit('request_success', 'fetch')

      return data
    } catch (err) {
      commit('request_failure', 'fetch')

      throw err
    }
  },

  updateInfo({ commit }, info) {
    commit('set_info', info)
  },

  updateInfoPhone({ commit }, phone) {
    commit('set_info_phone', phone)
  },

  updateInfoLocation({ commit }, location) {
    commit('set_info_location', location)
  },

  async updateBilling({ commit, state }) {
    commit('request_start', 'update')

    try {
      const model = formatBillingEdit(state.info)
      const result = await updateBillingData(model)

      commit('request_success', 'update')

      return result
    } catch (err) {

      commit('request_failure', 'update')
      throw err
    }
  }
}

export default {
  namespaced: true,

  getters,
  state,
  actions,
  mutations
}